import { ITypedReduxAction } from '../../types/redux/actionType';
import { ISeoData } from '../../types/seo';

export enum ESeoDataActionType {
  SetData = 'SeoData/SetSeoData',
}

export type TSeoDataActions = TSetSeoData;

export type TSetSeoData = ITypedReduxAction<ESeoDataActionType.SetData, ISeoData | null>;
